import { useEffect, useState } from 'react';

/** Capacitor emits these window events on both native platforms. */
export function useKeyboardVisible(enabled = true) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!enabled) {
      setVisible(false);
      return;
    }
    const show = () => setVisible(true);
    const hide = () => setVisible(false);
    window.addEventListener('keyboardWillShow', show);
    window.addEventListener('keyboardDidShow', show);
    window.addEventListener('keyboardWillHide', hide);
    window.addEventListener('keyboardDidHide', hide);
    return () => {
      window.removeEventListener('keyboardWillShow', show);
      window.removeEventListener('keyboardDidShow', show);
      window.removeEventListener('keyboardWillHide', hide);
      window.removeEventListener('keyboardDidHide', hide);
    };
  }, [enabled]);
  return visible;
}
